import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import { connect } from 'react-redux';
import {
  Container,
  Menu,
  Header,
  Grid,
  Icon,
  Button,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { decodeSearch, encodeSearch, AWSUrl } from '../../utils/url';
import NavBar from '../../components/NavBar';
import {
  BookingsByStatus,
  UsersBookings, UsersBookingsSortItems,
  BranchBookings, BranchBookingsSortItems,
  ProjectUnitsByStatus,
  BankAverageAging, BankAverageAgingSortItems,
  LawyersReports,
} from '../../components/Reports';
import { BookingDatePicker, BookingSelectList, BookingSelectListMultiple } from '../../components/Filters';
import SortButton from '../../components/SortButton';
import SearchIn from '../../components/SearchIn';
import PageNav from '../../components/PageNav';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM, fetchAPI } from '../../actions/fetchM';
import * as endpoints from '../../constants/apiEndpoints';
import config from '../../../config';
import { REPORT_DATE_RANGES } from '../../constants/dateRanges';
import { BANK_CASE_STATUS_GROUPS } from '../../constants/bankCaseStatuses';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class Overview extends Component {
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        companyID: PropTypes.int,
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    banks: PropTypes.shape({
      data: PropTypes.array,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    banks: state.banks,
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const isTablet = windowWidth >= 768 && windowWidth < 992;
    const query = decodeSearch(props.location.search);
    const projectID = query.projectID || '';
    const projectUnitLayoutID = query.projectUnitLayoutID || '';
    const search = query.search || '';
    const currentPage = parseInt(query.page, 10) || 1;
    const dateRange = query.dateRange || '';
    const dateFrom = query.dateFrom ? query.dateFrom : '';
    const dateTo = query.dateTo ? query.dateTo : '';
    const status = query.status || '';
    const bankID = query.bankID ? query.bankID : [];
    const statusGroup = query.statusGroup ? query.statusGroup : '';
    const lawyerID = query.lawyerID ? query.lawyerID : [];
    const firmName = query.firmName ? query.firmName : [];
    const businessUnitID = query.businessUnitID || '';
    return {
      isMobile,
      isTablet,
      currentPage,
      projectID,
      projectUnitLayoutID,
      search,
      dateRange,
      dateFrom,
      dateTo,
      status,
      statusGroup,
      bankID,
      lawyerID,
      firmName,
      businessUnitID,
    };
  }
  constructor(props) {
    super(props);
    const state = Overview.getPropsToState(props);
    const query = decodeSearch(props.location.search);
    this.state = {
      ...state,
      projectList: [],
      lawyerList: [],
      firmList: [],
      projectLayoutList: [],
      buList: [],
      loading: true,
      currentTab: query.tab || this.tabs(this.props.appConfig, this.props.auth)[0].value,
      count: 0,
      dataSize: 0,
      limit: 0,
      offset: 0,
      reportLoading: false,
      firmSelected: false,
      lawyerSelected: false,
    };
  }
  componentDidMount() {
    this.fetchProjectList();
    if (this.state.currentTab === 'project_unit') {
      if (this.state.projectID.length === 1) {
        this.fetchProjectLayoutList();
      } else {
        this.state.projectUnitLayoutID = '';
      }
    }
    this.fetchLawyerList();
    this.fetchFirmList();
    this.fetchBUList();
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = Overview.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  getCurrentTabData = (currentTab = this.state.currentTab) =>
    this.tabs(this.props.appConfig, this.props.auth).find(tab => currentTab === tab.value)
  getValueName = (value, arr) => {
    const valueName = arr.find(vn => vn.value === value);
    if (valueName && valueName.text) {
      return valueName.text;
    }
    return '';
  }
  getSearchPlaceholder = () => {
    const { currentTab } = this.state;
    switch (currentTab) {
      case 'user':
        return 'Search user';
      case 'business_unit':
        return 'Search branch';
      default:
        return 'Search';
    }
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchProjectList() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/search/projects/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      const projectList = this.editImageSrc(json);
      await this.setComponentState({
        projectList,
      });
    }
    await this.setLoading(false);
  }
  async fetchLawyerList() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.LAWYERS}/?limit=500`, null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (res) {
      const lawyerList = this.editLawyerData(res.items);
      await this.setComponentState({
        lawyerList,
      });
    }
    await this.setLoading(false);
  }
  async fetchFirmList() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    const company = this.props.appConfig.data.companyID;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.LAWYERS}/?limit=500&firm=true&company_id=${company}`, null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (res) {
      const firmList = this.editFirmData(res);
      await this.setComponentState({
        firmList,
      });
    }
    await this.setLoading(false);
  }
  async fetchProjectLayoutList() {
    await this.setLoading(true);
    const { store } = this.context;
    const { projectID } = this.state;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/search/project_unit_layouts/?projectID=${projectID}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const jsonData = await res.json();
      const projectLayoutList = this.editProjectLayoutData(jsonData);
      await this.setComponentState({
        projectLayoutList,
      });
    }
    await this.setLoading(false);
  }
  async fetchBUList() {
    await this.setLoading(true);
    const { store } = this.context;
    let res = null;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/?page=all&getProjects=true`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const jsonData = await res.json();
      const buList = this.editBUData(jsonData);
      await this.setComponentState({
        buList,
      });
    }
    await this.setLoading(false);
  }
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const isTablet = windowWidth >= 768 && windowWidth < 992;
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
    }
    if (isTablet !== this.state.isTablet) {
      state.isTablet = isTablet;
    }
    const keys = Object.keys(state);
    if (keys.length > 0) {
      this.setState({ ...state });
    }
  }
  editImageSrc = (data = []) => {
    const newData = [];
    data.forEach((d) => {
      const editData = {};
      editData.value = d.id;
      editData.text = d.shortName;
      const editImage = {};
      editData.image = editImage;
      editData.image.avatar = true;
      if (d.pictureKey !== '') {
        editData.image.src = AWSUrl(this.props.appConfig, `${d.pictureKey}010.jpg`);
      } else {
        editData.image.src = '/assets/images/placeholder_x100.jpg';
      }
      newData.push(editData);
    });
    return newData;
  }
  editProjectLayoutData = (data) => {
    if (data) {
      const newData = [];
      data.forEach((d) => {
        const editData = {};
        editData.value = d.id;
        editData.text = d.name;
        newData.push(editData);
      });
      return newData;
    }
    return [];
  }
  editLawyerData = (data) => {
    const newData = [];
    data.forEach((d) => {
      const editData = {};
      editData.value = d.id;
      editData.text = d.name;
      newData.push(editData);
    });
    return newData;
  }
  editFirmData = (data) => {
    const newData = [];
    data.forEach((d) => {
      const editData = {};
      editData.value = d;
      editData.text = d;
      newData.push(editData);
    });
    return newData;
  }
  editBUData = (data) => {
    const newData = [];
    data.forEach((d) => {
      const editData = {};
      editData.value = d.id.toString();
      editData.text = d.name;
      newData.push(editData);
    });
    return newData;
  }
  handleSetDateRange = (from, to) => {
    const query = decodeSearch(this.props.location.search);
    query.dateFrom = from;
    query.dateTo = to;
    this.replaceQuery(query);
  }

  handleFilterOnChange = (value, queryName) => {
    let clearSort = false;
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    if (queryName === 'statusGroup') {
      delete query.status;
      clearSort = true;
    }
    if (queryName === 'firmName') {
      this.setState({ firmSelected: true });
    }
    if (queryName === 'lawyerID') {
      this.setComponentState({ lawyerSelected: true });
    }
    if (queryName === 'projectID' && this.state.currentTab === 'project_unit') {
      if (value.length === 1) {
        this.setState({ projectLayoutList: [] }, () => {
          this.fetchProjectLayoutList();
          this.replaceQuery(query, clearSort);
        });
      } else {
        this.setState({ projectLayoutList: [] }, () => {
          delete query.projectUnitLayoutID;
          this.replaceQuery(query, clearSort);
        });
      }
    } else {
      this.replaceQuery(query, clearSort);
    }
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        if (filter === 'status' && query.statusGroup !== undefined) {
          delete query.statusGroup;
        }
        hasQuery = true;
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    }
    if (this.state.currentTab === 'project_unit') {
      this.setState({
        projectLayoutList: [],
      });
    }
    if (this.state.firmSelected || this.state.lawyerSelected) {
      this.setState({
        firmSelected: false,
        lawyerSelected: false,
      });
    }
  }
  handleChangeTab = (e, { name, value }) => {
    const query = decodeSearch(this.props.location.search);
    const currentTab = name || value;
    query.tab = currentTab;
    if (this.state.currentTab !== currentTab) {
      delete query.projectID;
      const { tabFilterNames } = this.getCurrentTabData();
      if (tabFilterNames.length > 0) {
        tabFilterNames.forEach((filter) => {
          delete query[filter];
        });
      }
    }
    this.replaceQuery(query, true);
    this.setState({
      currentTab,
      count: 0,
      dataSize: 0,
      limit: 0,
      offset: 0,
    });
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({ currentPage }, () => {
      this.replaceQuery(query);
    });
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query);
  }
  handleReportLoading = (reportLoading) => {
    this.setState({ reportLoading });
  }
  handleReportPageNav = ({ count, dataSize, limit, offset }) => {
    this.setState({ count, dataSize, limit, offset });
  }
  replaceQuery(q, clearSort = false) {
    const query = q;
    const { store } = this.context;
    const { pathname } = this.props.location;
    if (clearSort) {
      delete query.sortColumn;
      delete query.sortDirection;
    }
    const projectID = decodeSearch(this.props.location.search).projectID;
    const dateRange = decodeSearch(this.props.location.search).dateRange;
    const search = decodeSearch(this.props.location.search).search;
    if (
      (query.projectID && !projectID) ||
      (query.dateRange && !dateRange) ||
      (query.search && !search)
    ) {
      query.page = 1;
    }
    store.dispatch(replace(`${pathname}?${encodeSearch(query)}`));
  }
  exportURL = (url, filterNames = []) => {
    const q = decodeSearch(this.props.location.search);
    if (!q.page) q.page = 1;
    let exportUrl = `${config.get('bookApiURL')}${url}`;
    if (filterNames.length > 0) {
      filterNames.forEach((filter) => {
        if (filter === 'projectID' && this.checkMultiProjectFilterTab() && this.state[filter] && Array.isArray(this.state[filter]) && this.state[filter].length > 1) {
          let newValue;
          this.state[filter].forEach((v) => {
            newValue += `&${filter}=${v}`;
          });
          exportUrl += newValue;
        } else {
          exportUrl += `&${filter}=${this.state[filter]}`;
        }
      });
    }
    exportUrl = `${exportUrl}&page=${q.page}`;
    return exportUrl;
  }
  checkTab = (unit = 7, booking = 7, user = 7, branch = 7, banks = 7, lawyers = 7) => {
    switch (this.state.currentTab) {
      case 'project_unit':
        return unit;
      case 'booking':
        return booking;
      case 'user':
        return user;
      case 'business_unit':
        return branch;
      case 'banks':
        return banks;
      case 'lawyers':
        return lawyers;
      default:
        return unit;
    }
  }
  checkMultiProjectFilterTab = () => {
    switch (this.state.currentTab) {
      case 'project_unit':
        return true;
      case 'booking':
        return true;
      case 'user':
        return false;
      case 'business_unit':
        return false;
      case 'banks':
        return true;
      default:
        return false;
    }
  }
  hasBUFilterTab = () => {
    switch (this.state.currentTab) {
      case 'project_unit':
        return true;
      case 'booking':
        return true;
      case 'user':
        return false;
      case 'business_unit':
        return false;
      case 'banks':
        return false;
      default:
        return false;
    }
  }
  hasAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  tabs = (appConfig, auth) => [
    {
      value: 'project_unit',
      name: 'project_unit',
      text: 'Project Unit',
      header: 'Project Unit Statuses',
      subheader: 'Units by statuses',
      component: ProjectUnitsByStatus,
      filterNames: ['projectUnitLayoutID', 'businessUnitID'],
      tabFilterNames: ['projectUnitLayoutID', 'businessUnitID'],
      exportItems: [
        {
          text: 'CSV',
          href: '/reports/project_units/statuses/export/?fileType=csv',
        },
        {
          text: 'Excel',
          href: '/reports/project_units/statuses/export/?fileType=excel',
        },
      ],
      sortItems: [],
      barChart: true,
    },
    {
      value: 'booking',
      name: 'booking',
      text: 'Booking',
      header: 'Booking Statuses',
      subheader: 'Bookings by statuses',
      component: BookingsByStatus,
      filterNames: ['businessUnitID'],
      tabFilterNames: ['businessUnitID'],
      exportItems: [
        {
          text: 'CSV',
          href: '/reports/bookings/statuses/export/?fileType=csv',
        },
        {
          text: 'Excel',
          href: '/reports/bookings/statuses/export/?fileType=excel',
        },
      ],
      sortItems: [],
      barChart: true,
    },
    {
      value: 'user',
      name: 'user',
      text: 'User',
      header: 'User Bookings',
      subheader: 'Bookings by user and booking status',
      component: UsersBookings,
      filterNames: [],
      tabFilterNames: ['search', 'page'],
      exportItems: [
        {
          text: 'CSV',
          href: '/reports/users/bookings/export/?fileType=csv',
        },
        {
          text: 'Excel',
          href: '/reports/users/bookings/export/?fileType=excel',
        },
      ],
      sortItems: UsersBookingsSortItems,
      barChart: false,
    },
    {
      value: 'business_unit',
      name: 'business_unit',
      text: 'Business Unit',
      header: 'Business Unit Bookings',
      subheader: 'Bookings by business unit and booking status',
      component: BranchBookings,
      filterNames: [],
      tabFilterNames: ['search', 'page'],
      exportItems: [
        {
          text: 'CSV',
          href: '/reports/bookings/branch/export/?fileType=csv',
        },
        {
          text: 'Excel',
          href: '/reports/bookings/branch/export/?fileType=excel',
        },
      ],
      sortItems: BranchBookingsSortItems,
      barChart: false,
    },
    {
      value: 'banks',
      name: 'banks',
      text: 'Banks',
      header: 'Summary by Banks',
      subheader: 'Booking\'s average days summary by banks',
      component: BankAverageAging,
      filterNames: ['bankID', 'status', 'statusGroup'],
      tabFilterNames: ['bankID', 'status', 'statusGroup'],
      exportItems: [
        {
          text: 'CSV',
          href: '/reports/bookings/banks/export/?fileType=csv',
        },
        {
          text: 'Excel',
          href: '/reports/bookings/banks/export/?fileType=excel',
        },
      ],
      sortItems: BankAverageAgingSortItems,
      barChart: false,
      disabled: !(auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY'),
    },
    {
      value: 'lawyers',
      name: 'lawyers',
      text: 'Lawyers',
      header: 'Lawyers Summary',
      subheader: 'Lawyers cases count by status and type',
      component: LawyersReports,
      filterNames: ['lawyerID', 'firmName'],
      tabFilterNames: ['lawyerID', 'firmName'],
      exportItems: [],
      sortItems: [],
      barChart: false,
      disabled: !(appConfig.data && appConfig.data.lawyerIsEnabled),
    },
  ];
  render() {
    const { banks, t } = this.props;
    const {
      currentTab, isMobile, isTablet,
      currentPage, count, limit, offset, dataSize, reportLoading,
    } = this.state;
    const {
      header,
      subheader,
      barChart,
      component: CurrentTabComponent,
      filterNames,
      tabFilterNames,
      exportItems,
      sortItems,
    } = this.getCurrentTabData();
    const commonFilterNames = ['projectID', 'dateRange', 'dateTo', 'dateFrom', 'search'];
    const allFilterNames = [].concat(commonFilterNames, filterNames);
    const hasPage = tabFilterNames && tabFilterNames.length > 0 && tabFilterNames.some(filter => filter === 'page');
    const hasSearch = tabFilterNames && tabFilterNames.length > 0 && tabFilterNames.some(filter => filter === 'search');
    const exportOptions = exportItems.map(item => ({
      text: item.text,
      icon: 'download',
      href: this.exportURL(item.href, allFilterNames),
    }));
    const hasSortsOrExports = (
      (sortItems && sortItems.length > 0) ||
      (exportOptions && exportOptions.length > 0)
    );
    return (
      <Container>
        <NavBar
          header={t('Reports', { ns: 'screens' })}
        />
        <Grid verticalAlign="middle" className="booking-list">
          <Grid.Row className="tab-menu">
            <Grid.Column width={16}>
              <Menu
                attached="top"
                tabular
              >
                {
                  this.tabs(this.props.appConfig, this.props.auth).filter(tb => !tb.disabled).map((tab, key) => (
                    <Menu.Item
                      key={key}
                      name={tab.name}
                      onClick={this.handleChangeTab}
                      active={currentTab === tab.name}
                    >{t(tab.text).toUpperCase()}</Menu.Item>
                  ))
                }
              </Menu>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="toolbar">
            <Grid.Column width={16}>
              <Grid
                className="filters"
                columns="equal"
                textAlign="left"
                verticalAlign="middle"
              >
                <Grid.Row>
                  {
                    !isMobile && hasPage && (
                      <Grid.Column
                        className="pagination tablet-hide"
                        tablet={4}
                        computer={3}
                      >
                        <PageNav
                          currentPage={currentPage}
                          count={count}
                          limit={limit}
                          offset={offset}
                          dataSize={dataSize}
                          loading={reportLoading}
                          onChange={this.handleChangePage}
                          noScrollTop
                        />
                      </Grid.Column>
                    )
                  }
                  {(currentTab !== 'lawyers') && (
                  <Grid.Column
                    className="filter"
                    mobile={this.checkTab(7, 8, 7, 7, 7)}
                    tablet={this.checkTab(6, 8, 7, 7, 7)}
                    computer={this.checkTab(4, 4, 3, 3, 3)}
                    style={hasPage ? { paddingLeft: 0 } : {}}
                  >
                    <BookingDatePicker
                      filterName="dateRange"
                      filterNameFrom="dateFrom"
                      filterNameTo="dateTo"
                      dateFrom={this.state.dateFrom}
                      dateTo={this.state.dateTo}
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      onResetRange={this.handleClearFilter}
                      onSetRange={this.handleSetDateRange}
                      value={this.state.dateRange}
                      disabled={this.state.loading}
                      options={REPORT_DATE_RANGES}
                    />
                  </Grid.Column>
                  )}
                  <Grid.Column
                    className="filter"
                    mobile={this.checkTab(7, 8, 7, 7, 7, 8)}
                    tablet={this.checkTab(8, 7, 7, 7, 7, 5)}
                    computer={this.checkTab(4, 4, 3, 3, 3, 5)}
                  >
                    { this.checkMultiProjectFilterTab() ?
                      <BookingSelectListMultiple
                        filterName="projectID"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={this.state.projectList}
                        placeholder={t('Select Project')}
                        value={this.state.projectID || []}
                        disabled={this.state.loading}
                      />
                      :
                      <BookingSelectList
                        filterName="projectID"
                        onChange={this.handleFilterOnChange}
                        options={this.state.projectList}
                        placeholder={t('Select Project')}
                        headerText={t('Project')}
                        value={this.state.projectID}
                        disabled={this.state.loading}
                      />
                    }
                  </Grid.Column>
                  {
                    currentTab === 'lawyers' && (
                      <Grid.Column
                        className="filter"
                        mobile={8}
                        tablet={5}
                        computer={5}
                      >
                        <BookingSelectListMultiple
                          filterName="lawyerID"
                          onChange={this.handleFilterOnChange}
                          onClose={this.handleClearFilter}
                          options={this.state.lawyerList}
                          placeholder={t('Select Lawyer')}
                          value={this.state.lawyerID || []}
                          disabled={this.state.loading || this.state.firmSelected}
                        />
                      </Grid.Column>
                    )
                  }
                  {
                    currentTab === 'lawyers' && (
                      <Grid.Column
                        className="filter"
                        mobile={8}
                        tablet={4}
                        computer={4}
                        style={isMobile ? { paddingTop: '0.5rem' } : null}
                      >
                        <BookingSelectListMultiple
                          filterName="firmName"
                          onChange={this.handleFilterOnChange}
                          onClose={this.handleClearFilter}
                          options={this.state.firmList}
                          placeholder={t('Select Law Firm')}
                          value={this.state.firmName || []}
                          disabled={this.state.loading || this.state.lawyerSelected}
                        />
                      </Grid.Column>
                    )
                  }
                  {
                    currentTab === 'project_unit' && (
                      <Grid.Column
                        className="filter"
                        mobile={7}
                        tablet={6}
                        computer={4}
                        style={(isMobile || isTablet) ? {
                          paddingTop: '0.5rem',
                          paddingLeft: 0,
                        } : null}
                      >
                        <BookingSelectList
                          filterName="projectUnitLayoutID"
                          onChange={this.handleFilterOnChange}
                          options={this.state.projectLayoutList}
                          placeholder={t('Select Project Layout')}
                          headerText={t('Project Layout')}
                          value={this.state.projectUnitLayoutID}
                          disabled={this.state.loading || this.state.projectLayoutList.length < 1}
                          hasSearch
                        />
                      </Grid.Column>
                    )
                  }
                  {
                    this.hasBUFilterTab() && (
                      <Grid.Column
                        className="filter"
                        mobile={this.checkTab(7, 8)}
                        tablet={this.checkTab(8, 8)}
                        computer={this.checkTab(8, 6)}
                        style={(isMobile || isTablet || currentTab === 'project_unit') ? {
                          paddingTop: '0.5rem',
                          paddingLeft: 0,
                        } : null}
                      >
                        <BookingSelectList
                          filterName="businessUnitID"
                          onChange={this.handleFilterOnChange}
                          placeholder={t('Select Business Unit')}
                          headerText={t('Business Unit')}
                          options={this.state.buList}
                          value={this.state.businessUnitID}
                          disabled={this.state.loading}
                        />
                      </Grid.Column>
                    )
                  }
                  {
                    currentTab === 'banks' && (
                      <Grid.Column
                        className="filter"
                        mobile={7}
                        tablet={7}
                        computer={3}
                        style={(isMobile || isTablet) ? {
                          paddingTop: '0.5rem',
                          paddingLeft: 0,
                        } : null}
                      >
                        <BookingSelectListMultiple
                          filterName="bankID"
                          onChange={this.handleFilterOnChange}
                          options={banks ?
                            banks.data
                            .map((s, key) => ({
                              key,
                              text: s.name,
                              value: s.id.toString(),
                              name: s.id.toString(),
                            })) : []}
                          placeholder={t('Select Bank')}
                          headerText={t('Bank')}
                          value={this.state.bankID}
                          disabled={this.state.loading}
                        />
                      </Grid.Column>
                    )
                  }
                  {
                    currentTab === 'banks' && (
                      <Grid.Column
                        className="filter"
                        mobile={7}
                        tablet={7}
                        computer={3}
                        style={(isMobile || isTablet) ? { paddingTop: '0.5rem' } : null}
                      >
                        <BookingSelectList
                          filterName="statusGroup"
                          onChange={this.handleFilterOnChange}
                          options={BANK_CASE_STATUS_GROUPS}
                          placeholder={t('Select Status Group')}
                          headerText={t('Status Group')}
                          value={this.state.statusGroup}
                          disabled={this.state.loading}
                          hasSearch
                        />
                      </Grid.Column>
                    )
                  }
                  <Grid.Column
                    textAlign="right"
                    className="clear"
                    mobile={this.checkTab(2, 2, 2, 2, 2, 8)}
                    tablet={2}
                    computer={this.checkTab(1, 2, 2, 2, 4, 2)}
                  >
                    {
                      allFilterNames.some(filterName => this.state[filterName] &&
                      this.state[filterName].length > 0) ? (
                        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                        <a onClick={() => this.handleClearFilter(...allFilterNames)}>
                          <Icon name="remove" />
                          <span className="mobile-hide">{t('Clear').toUpperCase()}</span>
                        </a>
                      ) : null
                    }
                  </Grid.Column>
                  {
                    ((isMobile || isTablet) && hasPage) && (
                      <Grid.Column
                        mobile={8}
                        tablet={3}
                        style={{
                          paddingTop: '0.5rem',
                          paddingRight: '0.5rem',
                        }}
                      >
                        <PageNav
                          currentPage={currentPage}
                          count={count}
                          limit={limit}
                          offset={offset}
                          dataSize={dataSize}
                          loading={reportLoading}
                          onChange={this.handleChangePage}
                          noScrollTop
                        />
                      </Grid.Column>
                    )
                  }
                  {
                    hasSearch && (
                      <Grid.Column
                        className={hasPage ? 'mobile-padding-left' : null}
                        mobile={hasPage ? 8 : 16}
                        tablet={hasPage ? 13 : 16}
                        computer={currentTab === 'banks' ? 16 : 5}
                      >
                        <SearchIn
                          isLoading={this.state.loading}
                          onChange={this.handleFilterOnChange}
                          onClear={this.handleClearFilter}
                          search={this.state.search}
                          placeholder={this.getSearchPlaceholder()}
                        />
                      </Grid.Column>
                    )
                  }
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="app--listdata">
            <Grid.Column>
              <Grid className="booking-data">
                <Grid.Row className="header">
                  <Grid.Column
                    mobile={hasSortsOrExports ? 10 : 16}
                    tablet={hasSortsOrExports ? 8 : 16}
                    computer={hasSortsOrExports ? 9 : 16}
                  >
                    <Header
                      as="h2"
                      content={t(header)}
                      subheader={t(subheader)}
                    />
                  </Grid.Column>
                  {
                    hasSortsOrExports && (
                      <Grid.Column mobile={6} tablet={8} computer={7} textAlign="right" className="download">
                        {
                          exportOptions && exportOptions.length > 0 && (
                            <div className="title mobile-hide">{t('Download', { ns: TRANSLATION_FILES.translation })}</div>
                          )
                        }
                        {
                          exportOptions && exportOptions.length > 0 && (
                            <Button.Group basic className="mobile-hide">
                              {
                                exportOptions.map((item, idx) => (
                                  <Button
                                    key={idx}
                                    href={item.href}
                                    content={item.text}
                                  />
                                ))
                              }
                            </Button.Group>
                          )
                        }
                        {
                          sortItems && sortItems.length > 0 && (
                            <SortButton
                              floated="right"
                              loading={this.state.loading}
                              items={sortItems}
                              onSort={this.handleSortData}
                            />
                          )
                        }
                        {
                          exportOptions && exportOptions.length > 0 && (
                            <SortButton
                              className="tablet-hide small-hide large-hide"
                              floated="right"
                              icon="download"
                              loading={this.state.loading}
                              items={exportOptions}
                            />
                          )
                        }
                      </Grid.Column>
                    )
                  }
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <CurrentTabComponent
                      appConfig={this.props.appConfig}
                      location={this.props.location}
                      headerColor="blue"
                      barChart={barChart}
                      onLoading={this.handleReportLoading}
                      onPageNav={this.handleReportPageNav}
                      onFilterChange={this.handleFilterOnChange}
                      onFilterClose={this.handleClearFilter}
                      companyID={this.props.appConfig.data.companyID || 0}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Reports/Overview.jsx